import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Button, Container, Alert, Row, Col } from 'react-bootstrap'
import { stockItemCategoryAPI } from '../api/stockItemCategoryAPI'
import { formatErrorResponse } from '../utils/errorHandlers'
import { usePermissions } from '../contexts/PermissionContext'

function StockItemCategoryCreateScreen() {
    const { hasPermission, loading: permissionsLoading } = usePermissions()
    const navigate = useNavigate()
    const [error, setError] = useState(null)
    const [category, setCategory] = useState({
        name: '',
        is_active: true
    })

    const submitHandler = async (e) => {
        e.preventDefault()
        try {
            await stockItemCategoryAPI.create(category)
            navigate('/stock-item-categories')
        } catch (error) {
            setError(formatErrorResponse(error))
        }
    }

    if (permissionsLoading) {
        return (
            <Container className="py-3">
                <div className="text-center">Loading...</div>
            </Container>
        )
    }

    if (!hasPermission('stock.categories.modify')) {
        return (
            <Container className="py-3">
                <Alert variant="danger">
                    You don&apos;t have permission to create stock item categories.
                </Alert>
            </Container>
        )
    }

    return (
        <Container>
            <Row className="justify-content-left">
                <Col md={8} lg={6}>
                    <h1>Create Stock Item Category</h1>
                    <Form onSubmit={submitHandler}>
                        <Form.Group className="mb-4" controlId="name">
                            <Form.Label>Name*</Form.Label>
                            <Form.Control
                                type="text"
                                value={category.name}
                                onChange={(e) => setCategory({...category, name: e.target.value})}
                                required
                                placeholder="Enter name"
                                autoComplete="off"
                                spellCheck="false"
                            />
                        </Form.Group>
                        {error && (
                            <Alert variant="danger" onClose={() => setError(null)} dismissible>
                                {error}
                            </Alert>
                        )}  
                        <Button variant="success" type="submit" className="me-2">
                            Create
                        </Button>
                        <Button 
                            variant="outline-primary" 
                            onClick={() => navigate('/stock-item-categories')}
                        >
                            <i className="fas fa-arrow-left me-2"></i>
                            Back to List
                        </Button>
                    </Form>
                </Col>
            </Row>
        </Container>
    )
}

export default StockItemCategoryCreateScreen 